import {createAsyncThunk} from "@reduxjs/toolkit"
import {AppThunkProps} from "store"
import {api} from "utils/http"
import {Application} from "types/Application"

type ReturnedType = {
    status: "success"
    application: Application
}

interface ArgsProps {
    id: Application["id"]
    data: {
        order_products: string
    }
}

export const assembleMenuApplication = createAsyncThunk<ReturnedType, ArgsProps, AppThunkProps>(
    "application/assemble-menu",
    async ({id, data}, {signal}) => {
        return api.post<ReturnedType>(`/user/application/${id}/assemble-menu`, data, {signal})
    }
)
